import React from 'react';

import {Helmet} from "react-helmet";
import HeaderContainer from 'containers/HeaderContainer';
import Footer from 'views/Footer';
import CacheService from 'service/CacheService';

class AnalyticsOptOutPage extends React.Component {

	constructor(props) {
		super(props);
		this.CACHE_KEY = "analytics-opt-out";
		this.handleCheckBoxClick = this.handleCheckBoxClick.bind(this);
		this.state = {optedOut: Boolean(CacheService.get(this.CACHE_KEY)) === true};
	}

	handleCheckBoxClick(event) {
		const target = event.target;
		const isChecked = target.checked;

		if(isChecked)
			CacheService.save(this.CACHE_KEY, isChecked, true);
		else
			CacheService.remove(this.CACHE_KEY);
		
		this.setState({optedOut: isChecked});
	}

	render() {
		return (
				<div>
					<Helmet>
						<title>Opt Out from Analytics | Seto Canvas</title>
					</Helmet>
					<HeaderContainer />		
					
					<div style={{textAlign: 'center', padding: '20px', fontSize: '150%'}}>
						{
							this.state.optedOut &&
							<h3 style={{background: 'gray', color: 'white', padding: '5px'}}>You have opted out from analytics!</h3>
						}
						<input style={{cursor: 'pointer'}} checked={this.state.optedOut} type="checkbox" id="optout" name="optout" onChange={this.handleCheckBoxClick} /> Opt Out from Analytics
					</div>

					<Footer />
				</div>
			);
		
	}
}


export default AnalyticsOptOutPage;


// WEBPACK FOOTER //
// ./src/pages/AnalyticsOptOutPage.js